var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.clips),function(clip,index){return _c('span',{key:index,ref:"clips",refInFor:true,style:(_vm.clipStyle(clip)),attrs:{"clipIndex":index,"textIndex":clip.from},on:{"click":function($event){return _vm.clicked(clip)}}},[_vm._v(_vm._s(_vm.textOf(clip)))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }